<template>
  <div class="surface-design-placements">
    <TopPanel
      @search="surfaceDesignPrintPlacementsStore.searchByCollections"
      @sort-order="surfaceDesignPrintPlacementsStore.setSortOrderCollections"
      @sort-option="surfaceDesignPrintPlacementsStore.sortCollection"
      @create-new="surfaceDesignPrintPlacementsStore.createModalToggle"
      :sort-options="sortOptions"
    >
    </TopPanel>
    <EmptyGrid v-if="surfaceDesignPrintPlacementsStore.count === 0"
      @create-new="surfaceDesignPrintPlacementsStore.createModalToggle()">
      <template v-slot:icon>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22">
          <path d="M4.582 2.916c-.912 0-1.666.756-1.666 1.668v12.832c0 .912.754 1.668 1.666 1.668h12.834c.912 0 1.666-.756 1.666-1.668V4.584c0-.912-.754-1.668-1.666-1.668H4.582zm-.018 1.5h12.852c.101 0 .166.067.166.168v12.832c0 .1-.065.168-.166.168H4.582c-.1 0-.166-.067-.166-.168V4.584c0-.095.058-.16.148-.168zM9.166 7.5c-.912 0-1.666.754-1.666 1.666v3.668c0 .912.754 1.666 1.666 1.666h3.668c.912 0 1.666-.754 1.666-1.666V9.166c0-.912-.754-1.666-1.666-1.666H9.166zM9.148 9h3.686c.101 0 .166.065.166.166v3.668c0 .101-.065.166-.166.166H9.166c-.1 0-.166-.065-.166-.166V9.166c0-.095.058-.158.148-.166z" />
        </svg>
      </template>
      <template v-slot:title>You haven't created any print library yet</template>
      <template v-slot:text>Here you can create your new print template and use it for your future designs.</template>
      <template v-slot:button-text>Create collection</template>
    </EmptyGrid>
    <template v-if="surfaceDesignPrintPlacementsStore.count > 0">
      <ElementsGrid>
        <Collection
          v-for="collection in surfaceDesignPrintPlacementsStore.list"
          :key="collection.id"
          :collection="collection"
          selectedTab="print placement"
          :designsCount="collection.printPlacementsCount"
          @open="openLink(collection)"
          @edit="editModal"
          @delete="delModal"
          :prewiev="collection.PrintPlacementsPreview"
        >
          <template v-slot:icon>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22">
              <path d="M4.582 2.916c-.912 0-1.666.756-1.666 1.668v12.832c0 .912.754 1.668 1.666 1.668h12.834c.912 0 1.666-.756 1.666-1.668V4.584c0-.912-.754-1.668-1.666-1.668H4.582zm-.018 1.5h12.852c.101 0 .166.067.166.168v12.832c0 .1-.065.168-.166.168H4.582c-.1 0-.166-.067-.166-.168V4.584c0-.095.058-.16.148-.168zM9.166 7.5c-.912 0-1.666.754-1.666 1.666v3.668c0 .912.754 1.666 1.666 1.666h3.668c.912 0 1.666-.754 1.666-1.666V9.166c0-.912-.754-1.666-1.666-1.666H9.166zM9.148 9h3.686c.101 0 .166.065.166.166v3.668c0 .101-.065.166-.166.166H9.166c-.1 0-.166-.065-.166-.166V9.166c0-.095.058-.158.148-.166z" />
            </svg>
          </template>
        </Collection>
      </ElementsGrid>
      <PaginationComponent
        :limit="surfaceDesignPrintPlacementsStore.collectionsParams.limit"
        :offset="surfaceDesignPrintPlacementsStore.collectionsParams.offset"
        :total="surfaceDesignPrintPlacementsStore.count"
        @setOffset="setOffset"
      />
    </template>
    <ModalComponent @close="surfaceDesignPrintPlacementsStore.createModalToggle()"
      :show="surfaceDesignPrintPlacementsStore.createModal">
      <template v-slot:icon>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22">
          <path d="M4.582 2.916c-.912 0-1.666.756-1.666 1.668v12.832c0 .912.754 1.668 1.666 1.668h12.834c.912 0 1.666-.756 1.666-1.668V4.584c0-.912-.754-1.668-1.666-1.668H4.582zm-.018 1.5h12.852c.101 0 .166.067.166.168v12.832c0 .1-.065.168-.166.168H4.582c-.1 0-.166-.067-.166-.168V4.584c0-.095.058-.16.148-.168zM9.166 7.5c-.912 0-1.666.754-1.666 1.666v3.668c0 .912.754 1.666 1.666 1.666h3.668c.912 0 1.666-.754 1.666-1.666V9.166c0-.912-.754-1.666-1.666-1.666H9.166zM9.148 9h3.686c.101 0 .166.065.166.166v3.668c0 .101-.065.166-.166.166H9.166c-.1 0-.166-.065-.166-.166V9.166c0-.095.058-.158.148-.166z" />
        </svg>
      </template>
      <template v-slot:title>New print library</template>
      <template v-slot:description>Create name for the new library</template>
      <template v-slot:extra>
        <label class="new-collection-field">
          <span>Print library name</span>
          <input type="text" placeholder="" v-model="surfaceDesignPrintPlacementsStore.collectionName">
        </label>
      </template>
      <template v-slot:buttons>
        <ButtonSecondary class="small" @click.native="surfaceDesignPrintPlacementsStore.createModalToggle()">
          Cancel
        </ButtonSecondary>
        <ButtonPrimary class="small" :disabled="surfaceDesignPrintPlacementsStore.collectionName?.length === 0"
          @click.native="surfaceDesignPrintPlacementsStore.create($router)">
          Create
        </ButtonPrimary>
      </template>
    </ModalComponent>
    <ModalComponent @close="surfaceDesignPrintPlacementsStore.renameModalToggle()"
      :show="surfaceDesignPrintPlacementsStore.renameModal">
      <template v-slot:icon>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="none" viewBox="0 0 32 32">
          <path d="M21.334 5.14a2.08 2.08 0 0 0-1.475.606l-4.39 4.39L4.803 20.804a.75.75 0 0 0-.219.531v5.332a.75.75 0 0 0 .75.75h5.332a.75.75 0 0 0 .531-.219L21.863 16.53l4.39-4.388a2.096 2.096 0 0 0 0-2.948l-3.446-3.447a2.076 2.076 0 0 0-1.473-.605zm0 1.49c.148 0 .295.06.412.177l3.447 3.447a.574.574 0 0 1 0 .826l-3.859 3.86-4.271-4.272 3.859-3.861a.581.581 0 0 1 .412-.176zM16 11.73 20.273 16l-9.918 9.916H6.084v-4.271L16 11.729z"/>
        </svg>
      </template>
      <template v-slot:title>Rename collection</template>
      <template v-slot:extra>
        <label class="edit-collection-field">
          <span>Collection Name</span>
          <input type="text" placeholder="" v-model="surfaceDesignPrintPlacementsStore.collectionName">
        </label>
      </template>
      <template v-slot:buttons>
        <ButtonSecondary class="small" @click.native="surfaceDesignPrintPlacementsStore.renameModalToggle()">
          Cancel
        </ButtonSecondary>
        <ButtonPrimary class="small" :disabled="surfaceDesignPrintPlacementsStore.collectionName?.length === 0"
          @click.native="surfaceDesignPrintPlacementsStore.updateCollection()">
          Rename
        </ButtonPrimary>
      </template>
    </ModalComponent>
    <ModalComponent @close="surfaceDesignPrintPlacementsStore.delCollectionModalToggle()" type="error"
      :show="surfaceDesignPrintPlacementsStore.delCollectionModal">
      <template v-slot:title>Delete collection</template>
      <template v-slot:description>Are you sure? You will lose the prints that are in it</template>
      <template v-slot:buttons>
        <ButtonSecondary class="small" @click.native="surfaceDesignPrintPlacementsStore.delCollectionModalToggle()">
          Cancel
        </ButtonSecondary>
        <ButtonPrimary class="small" @click.native="surfaceDesignPrintPlacementsStore.deleteCollection()">
          <template v-slot:icon>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="none" viewBox="0 0 21 20">
              <path d="M8 1.75c-.866 0-1.584.718-1.584 1.584v.916H3.834a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h.916v10.916c0 .866.718 1.584 1.584 1.584h8.332c.866 0 1.584-.718 1.584-1.584V5.75h.916a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75h-2.582v-.916c0-.866-.718-1.584-1.584-1.584H8zm0 1.5h5c.055 0 .084.03.084.084v.916H7.916v-.916c0-.055.03-.084.084-.084zm-1.75 2.5h8.5v10.916c0 .055-.03.084-.084.084H6.334c-.055 0-.084-.03-.084-.084V5.75z" color="#000" style="-inkscape-stroke:none"/>
            </svg>
          </template>
          Delete
        </ButtonPrimary>
      </template>
    </ModalComponent>
    <ExpiredDemoMode />
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useSurfaceDesignPrintPlacementsStore } from '@/store/pinia/surfaceDesignPrintPlacements'

import TopPanel from '@/components/SurfaceDesign/TopPanel.vue'
import EmptyGrid from '@/components/Atoms/EmptyGrid.vue'
import ElementsGrid from '@/components/Atoms/ElementsGrid.vue'
import Collection from '@/components/SurfaceDesign/Collection.vue'
import ModalComponent from '@/components/Atoms/ModalComponent.vue'
import ButtonPrimary from '@/components/Atoms/ButtonPrimary.vue'
import ButtonSecondary from '@/components/Atoms/ButtonSecondary.vue'
import PaginationComponent from '@/components/Atoms/PaginationComponentLimit.vue'
import ExpiredDemoMode from '@/components/ExpiredDemoMode.vue'

export default {
  name: 'surfaceDesignPrintPlacements',
  components: {
    ExpiredDemoMode,
    TopPanel,
    EmptyGrid,
    ElementsGrid,
    Collection,
    ModalComponent,
    ButtonPrimary,
    ButtonSecondary,
    PaginationComponent,
  },
  computed: {
    ...mapStores(useSurfaceDesignPrintPlacementsStore),
  },
  data: () => ({
    sortOptions: [
      { name: 'Sort by', value: '' },
      { name: 'Name', value: 'title' },
      { name: 'Last edited', value: 'updatedAt' },
      { name: 'Number of prints', value: 'printPlacementsCount' },
    ],
  }),
  methods: {
    async openLink (collection) {
      this.surfaceDesignPrintPlacementsStore.selectCollectionId(collection.id)
      this.surfaceDesignPrintPlacementsStore.selectCollection(collection)
      this.surfaceDesignPrintPlacementsStore.selectedCollectionName = collection.title
      this.$router.push('/user/surface-design-print-placement/' + collection.id)
    },
    delModal (payload) {
      this.surfaceDesignPrintPlacementsStore.delCollectionModalToggle()
      this.surfaceDesignPrintPlacementsStore.collectionId = payload.id
    },
    editModal (payload) {
      this.surfaceDesignPrintPlacementsStore.renameModalToggle()
      this.surfaceDesignPrintPlacementsStore.collectionId = payload.id
      this.surfaceDesignPrintPlacementsStore.collectionName = payload.title
    },
    async setOffset (offset) {
      this.surfaceDesignPrintPlacementsStore.collectionsParams.offset = offset
      await this.surfaceDesignPrintPlacementsStore.getList()
    },
  },
  async beforeMount () {
    await this.surfaceDesignPrintPlacementsStore.getList()
  },
}
</script>

<style lang="scss">
.surface-design-placements {
  padding: 0 16px 40px 40px;
}

.new-collection-field, .edit-collection-field {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  row-gap: 8px;

  span {
    color: var(--Text-Text_Secondary);
    font-family: "DM Sans";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  input {
    border-radius: 8px;
    border: 1px solid var(--Dividers);
    background: var(--Background);
    padding: 10px 12px;

    color: var(--Text-Text_Primary);
    font-family: "DM Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
}
@media (max-width: 960px) {
  .surface-design-placements {
    .elements-grid {
      grid-template-columns: 1fr 1fr;
    }
  }
}
@media (max-width: 760px) {
  .surface-design-placements {
    padding: 0 0 40px 0 !important;

    h1 {
      font-size: 24px !important;
      button {
        display: block;
      }
    }
  }
}

@media (min-width: 761px) and (max-width: 1194px) {
  .surface-design-placements {
    h1 {
      margin-bottom: 0;
    }

    .user-top-panel {
      .left-side {
        margin-bottom: 16px;
      }
    }
  }
}
</style>
